// Deep links for settling a debt outside the app.
//
// Venmo supports a real prefilled link; the https form universal-links into the
// native app on iOS and falls back to web, so it beats the venmo:// scheme.
// Zelle has no public prefill scheme at all — it lives inside each bank's app —
// so the best we can do is copy the handle and open zellepay.com.

// Plain decimal dollars, no currency symbol — Venmo's `amount` param wants
// "23.50", not "$23.50". Amounts are stored as integer cents/pence.
export function amountToDecimal(cents: number): string {
  return (cents / 100).toFixed(2);
}

const VENMO_NOTE = "Flat expenses";

export function venmoLink(handle: string, amountCents: number): string {
  const h = handle.replace(/^@/, "");
  const params = new URLSearchParams({
    txn: "pay",
    amount: amountToDecimal(amountCents),
    note: VENMO_NOTE,
  });
  return `https://venmo.com/${encodeURIComponent(h)}?${params.toString()}`;
}

export const ZELLE_URL = "https://www.zellepay.com/";
